import Facebook from '@/icons/facebook';
import FlexcarWordmark2024 from '@/icons/flexcar-wordmark-2024';
import Instagram from '@/icons/instagram';
import LinkedIn from '@/icons/linkedin';
import TikTok from '@/icons/tiktok';
import XFormerlyTwitter from '@/icons/x-formerly-twitter';
import { cn } from '@/shadcn-ui/utils';
import { colors } from '@/theme/colors';
import { Link } from 'react-router';

const socialMediaLinks = [
  { Icon: Facebook, url: 'https://www.facebook.com/Flexcar/' },
  { Icon: Instagram, url: 'https://www.instagram.com/flexcar/?hl=en' },
  { Icon: XFormerlyTwitter, url: 'https://www.twitter.com/flexcar/' },
  {
    Icon: LinkedIn,
    url: 'https://www.linkedin.com/company/flexcar_official/mycompany/',
  },
  { Icon: TikTok, url: 'https://www.tiktok.com/@flexcar' },
];

export default function LogoAddressAndSocials() {
  return (
    <div className="flex flex-col gap-[40px]">
      <div className="flex flex-col">
        <FlexcarWordmark2024
          className="h-[40px] w-[106px]"
          fillPrimary={colors.neutral60}
        />
        <p className={cn('homepage-hero-body3')}>Live large. Spend small.</p>
      </div>
      <div className="flex flex-col gap-[8px]">
        <div className="flex flex-shrink-0 gap-[16px]">
          {socialMediaLinks.map(({ Icon, url }) => (
            <Link to={url} target="_blank" rel="noreferrer" key={url}>
              <Icon className="flex-shrink-0" />
            </Link>
          ))}
        </div>
        <p className={cn('homepage-footer')}>
          Flexcar, LLC PO Box 961270 Boston, MA 02196
        </p>
      </div>
    </div>
  );
}
